export default "__VITE_ASSET__DvPjyGLP__"